import { QRFC } from "./QRFC.js";
import { enumUIModes } from "../constants";

export class QLoadOverrideRFC extends QRFC {
  constructor() {
    super();
  }

  InitLoadOverride(callbackObj, parent) {
    callbackObj.fParent = parent;
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user, data) {
    this.AddParameter("data", data);
    this.AddParameter("mode", "polloverride");
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, planMgr) {
    var wsMgr = planMgr.fWSMgr;
    var r = this.SafeParseResponse(response, error => {
      planMgr.AbortPlanningMode({
        errorCode: error.code
      });
    });

    if (!r) return; // Parse failed, abort was called

    var success = r["success"];
    var doc = planMgr.GetDoc();

    var abort = !success || doc == null || !wsMgr.fCanvasPanel.IsShown();
    if (abort) {
      planMgr.AbortPlanningMode({ errorCode: r["code"] });
      return;
    }

    var conflictsDetected = r["isConflicts"];
    var code = r["code"];

    if (conflictsDetected) {
      var msg = "Could not complete action: ";
      var type = "";

      switch (code) {
        case "0110":
          planMgr.PlanNavigationAlert(wsMgr, r["conflictingID"]);
          return;
        case "0100":
          type = "ADD";
          break;
        case "0200":
          type = "DELETE";
          break;
        case "0300":
          type = "CHANGE";
          break;
        case "0400":
          type = "MOVE";
          break;
        case "0500":
          type = "COMMENT";
          break;
        default:
          type +=
            "Unknown Error Occurred. Please try again. If issue persists, please contact support";
          break;
      }

      msg += type + "\n" + "\n" + r["message"];
      planMgr.PlanAlert(msg);
    }

    var planInfo = planMgr.fPlanInfo;
    if (r["talentPoolUpdate"] != null) {
      planMgr.UpdateTalentPool(r["talentPoolUpdate"]);

      if (r["hashes"]) {
        planMgr.SetTalentPoolHash(r["hashes"]["talentPoolmd5"]);
      }
    }

    if (r["hashes"]) {
      planMgr.SetOverrideHash(r["hashes"]["overridemd5"]);
    }

    if (r["pickListMismatch"] != null) planMgr.SetPickListMismatch(r["pickListMismatch"]);

    // TODO: can probably remove more of this now that 'polling' is handled elsewhere
    if (r["status"]) {
      planInfo["status"] = r["status"];
    }

    if (r["users"]) {
      planInfo["users"] = r["users"];
    }

    if (r["fields"]) {
      planMgr.UpdateFields(r["fields"]);
    }

    planMgr.UpdateContext();

    if (doc) {
      var scm = doc.GetSubChartMgr();
      var sc = scm.GetActiveSubChart();
      var subRef = sc.GetTopDBObjRef();
      doc.DoChartDataQuery(subRef, null);
    }

    planMgr.SimulateSaveFeedback();
    wsMgr.UpdateDocContext();

    if (r.proposed_override_id) {
      planMgr.PlanAlert(r["message"], "Conflict auto-resolved");
    }
  }
}
